import { IconButton } from '@mui/material'

import { useStyles } from './styles'

interface IProps {
  approvedConnection: boolean | null
  disableTooltip?: boolean
}

export const AccountConnectionIndicator = ({ approvedConnection, disableTooltip }: IProps) => {
  const classes = useStyles()

  return (
    <IconButton
      disableTouchRipple
      disableFocusRipple
      disableRipple={disableTooltip}
      sx={{ cursor: 'inherit' }}
    >
      <span
        style={{
          backgroundColor:
            typeof approvedConnection === 'object'
              ? 'gray'
              : approvedConnection
              ? 'green'
              : 'orange',
        }}
        className={classes.statusIcon}
      />
    </IconButton>
  )
}

//  :
